var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMicon = function SvgMicon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.75C12 2.67893 10.3211 1 8.25 1C6.17893 1 4.5 2.67893 4.5 4.75V10.75C4.5 12.8211 6.17893 14.5 8.25 14.5C10.3211 14.5 12 12.8211 12 10.75V4.75Z",
    stroke: "#8B5CF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17.5V20.5",
    stroke: "#8B5CF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.75C15 12.5402 14.2888 14.2571 13.023 15.523C11.7571 16.7888 10.0402 17.5 8.25 17.5C6.45979 17.5 4.7429 16.7888 3.47703 15.523C2.21116 14.2571 1.5 12.5402 1.5 10.75",
    stroke: "#8B5CF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMicon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxNiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDQuNzVDMTIgMi42Nzg5MyAxMC4zMjExIDEgOC4yNSAxQzYuMTc4OTMgMSA0LjUgMi42Nzg5MyA0LjUgNC43NVYxMC43NUM0LjUgMTIuODIxMSA2LjE3ODkzIDE0LjUgOC4yNSAxNC41QzEwLjMyMTEgMTQuNSAxMiAxMi44MjExIDEyIDEwLjc1VjQuNzVaIiBzdHJva2U9IiM4QjVDRjYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguMjUgMTcuNVYyMC41IiBzdHJva2U9IiM4QjVDRjYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE1IDEwLjc1QzE1IDEyLjU0MDIgMTQuMjg4OCAxNC4yNTcxIDEzLjAyMyAxNS41MjNDMTEuNzU3MSAxNi43ODg4IDEwLjA0MDIgMTcuNSA4LjI1IDE3LjVDNi40NTk3OSAxNy41IDQuNzQyOSAxNi43ODg4IDMuNDc3MDMgMTUuNTIzQzIuMjExMTYgMTQuMjU3MSAxLjUgMTIuNTQwMiAxLjUgMTAuNzUiIHN0cm9rZT0iIzhCNUNGNiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";